import { Component, OnInit, Input, AfterViewInit, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { ClassService, ConfigService, ScriptLoaderService } from './../../../../../../_services';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { SwalComponent, SwalPartialTargets } from '@toverux/ngx-sweetalert2';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Config } from '../../../../../../_models/config';


@Component({
    selector: 'app-configs-deadline-modal',
    templateUrl: './configs-deadline-modal.component.html',
    styles: []
})
export class ConfigsDeadlineModalComponent implements OnInit, AfterViewInit, OnChanges {
    @Input() config_id: number;
    public config: any = {};

    @BlockUI() blockUI: NgBlockUI;
    @ViewChild('successSwal') private successSwal: SwalComponent;
    @ViewChild('errorSwal') private errorSwal: SwalComponent;
    model = new Config(null, null, null, null, null, null, null);

    constructor(private _configService: ConfigService,
        private _script: ScriptLoaderService,
  			      /*private _modalService: NgbModal*/) { }

    ngOnInit() {

    }

    ngAfterViewInit() {
        this._script.loadScripts('app-configs-modal', ['assets/demo/demo2/custom/crud/forms/widgets/bootstrap-select.js']);

    }

    ngOnChanges(changes: SimpleChanges) {
        if ('config_id' in changes) {
            let config_id = changes['config_id'].currentValue;
            this.config_id = config_id;
            if (this.config_id)
                this.getConfig(this.config_id);
        }
    }

    getConfig(id) {
        this.blockUI.start();
        this._configService.get(id).subscribe(data => {
            this.config = data.data;
            if (this.config['type'] == 'limit_date') {
                ($("#deadline") as any).selectpicker('show');
                let limit_date_name = this.config['value'];
                switch (limit_date_name) {
                    case "first":
                        limit_date_name = 'Primer día del mes';
                        break;

                    case "last":
                        limit_date_name = 'Último día del mes';
                        break;

                    default:
                        limit_date_name = this.config['value'];
                        break;
                }
                let options = `<option value="${this.config['value']}">` + limit_date_name + `</option>`;
                options += (this.config['value'] != 'first') ? `<option value="first">Primer día del mes</option>` : ``;
                options += (this.config['value'] != 'last') ? `<option value="last">Último día del mes</option>` : ``;
                for (let i = 1; i <= 31; i++) {
                    options += (this.config['value'] != i) ? `<option value="${i}">` + i + `</option>` : ``;

                }
                ($("#deadline").html(options) as any).selectpicker('refresh');
            }
            else {
                ($("#deadline") as any).selectpicker('hide');
                this.model.value = this.config['value'];
            }
            this.blockUI.stop();

        }, err => {
            this.blockUI.stop();
        }, () => {

        });
    }

    updateConfig() {
        this.blockUI.start();
        this._configService.putDeadline(this.config_id, this.model).subscribe(response => {
            this.blockUI.stop();
            this.successSwal.text = response.message;
            this.successSwal.show();

        }, err => {
            this.blockUI.stop();
            this.errorSwal.text = err;
            this.errorSwal.show();
        }, () => {

        });
    }

    reload() {
        window.location.reload();
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/configs/configs-modals/deadline-modal/configs-deadline-modal.component.ts